import { ref, watch } from "vue";
import { useEnv } from "@/composables/useEnv";

const key = useEnv().withPrefix("receipt_printer");
const receiptPrinter = ref<string | null>(sessionStorage.getItem(key));

watch(receiptPrinter, (value) => {
  if (value) sessionStorage.setItem(key, value);
  else sessionStorage.removeItem(key);
});

export function useReceiptPrinter() {
  return receiptPrinter;
}
